export default __webpack_public_path__ + "static/media/cancel-any-time.aca518cd.png";